<template>
    <div class="user-modal__login">
        <form action="#" @submit.prevent="login" novalidate>
            <div class="floating-input-wrapper">
                <input v-model="email"  type="email" name="email" class="floating-input" aria-label="דוא''ל" required>
                <span v-bind:class="errors.email ? 'label-error floating-label' : 'floating-label'">
                    דוא''ל
                    <span class="required-star">*</span>
                </span>
            </div>
            <div class="floating-input-wrapper">
                <input v-model="password"  type="password" name="password" class="floating-input" aria-label="סיסמה" required>
                <span v-bind:class="errors.email ? 'label-error floating-label' : 'floating-label'">
                    סיסמה
                    <span class="required-star">*</span>
                </span>
            </div>
            <div v-if="hasErrors" style="text-align: center;color: red">
                שם משתמש או סיסמה שגויים
            </div>
            <button type="submit" class="btn-black user-btn__login" aria-label="התחבר">
                התחבר
            </button>
            <div class="user-modal__links">
                <a v-on:click="(event) => onClickButton(event, 'Sms')" >
                  התחברות דרך סמס?
                </a>
                <a v-on:click="(event) => onClickButton(event, 'Forget')" style="margin-bottom: 1.5625vw;">
                    שכחת ססמא?
                </a>
                <a :href="registerLink">
                    אין לך חשבון? הרשמה
                </a>
            </div>
        </form>
    </div>
</template>

<script>
    import axios from 'axios';


    export default {
        name: 'Login',
        props: {
            modelValue: Object
        },
        computed: {
            hasErrors(){
                return Object.values(this.errors).length > 0
            },
            registerLink() {
                return route('client.registration')
            },
        },
        data() {
            return {
                email: '',
                password: '',
                errors: {}
            }
        },
        mounted() {
        },
        methods: {
            login () {
                this.errors = {};
                axios.post('/customer-login', {
                    email: this.email,
                    password: this.password,
                })
                    .then((response) => {
                       if(response.data.success) {
                           window.location.reload();
                       }
                    })
                    .catch((e) => {
                        this.errors = e.response.data.errors;
                    })
            },
            onClickButton (event, value) {
                this.$emit('clicked', value)
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "~styles/_mixins.scss";

    .th__user {
        &__modal {
            &__login {
                p {
                    margin-bottom: cvw(36px);
                }

            }
        }
    }
    @include bp(md) {
        .th__user {
            &__modal {
                &__login {
                    p {
                        margin-bottom: cvwt(22px);
                    }

                }
            }
        }
    }
    @include bp(sm) {
        .th__user {
            &__modal {
                &__login {
                    p {
                        margin-bottom: cvm(19px);
                    }

                }
            }
        }
    }
</style>
